import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React from 'react';
import { withTranslation } from 'react-i18next';
import { COLUMNS_ICON_CONFIG } from '../../constants/column';
import Select from '../../components/select';
import InlineElementUtils from '../editor-utils/inline-element-utils';
import EditorContext from '../editor-context';
var NOT_SUPPORT_COLUMN_TYPES = ['button', 'file'];
var Column = /*#__PURE__*/function (_React$Component) {
  _inherits(Column, _React$Component);
  var _super = _createSuper(Column);
  function Column(props) {
    var _this;
    _classCallCheck(this, Column);
    _this = _super.call(this, props);
    _this.getColumnByKey = function (key) {
      var column = _this.columns.find(function (item) {
        return item.key === key;
      });
      return column || null;
    };
    _this.getSelectOptions = function () {
      return _this.columns.map(function (item) {
        var iconClass = COLUMNS_ICON_CONFIG[item.type];
        return {
          value: item.key,
          label: item.name,
          bold: false,
          italic: false,
          iconClass: iconClass
        };
      });
    };
    _this.getDefaultOption = function () {
      var node = _this.props.node;
      var _ref = node || {},
        data = _ref.data; // column model
      var column = _this.getColumnByKey(data.key);
      var value = column && column.key || '';
      var optionIndex = _this.options.findIndex(function (item) {
        return item.value === value;
      });
      if (optionIndex === -1) return null;

      // used the old properties
      var option = _this.options[optionIndex];
      var currentOption = _objectSpread(_objectSpread({}, option), {
        bold: data.bold,
        italic: data.italic
      });
      _this.options.splice(optionIndex, 1, currentOption);
      return currentOption;
    };
    _this.onColumnChanged = function (option) {
      var data = _this.props.data;
      var key = option.value,
        name = option.label,
        bold = option.bold,
        italic = option.italic;
      var newData = _objectSpread(_objectSpread({}, data), {
        key: key,
        name: name,
        bold: bold,
        italic: italic
      });
      _this.inlineElementUtils.setSeatableColumn(newData);
    };
    var editor = EditorContext.getEditor();
    _this.inlineElementUtils = new InlineElementUtils(editor);
    _this.columns = editor.columns.filter(function (column) {
      return !NOT_SUPPORT_COLUMN_TYPES.includes(column.type);
    });
    _this.options = _this.getSelectOptions();
    return _this;
  }
  _createClass(Column, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        attributes = _this$props.attributes,
        children = _this$props.children,
        isSelected = _this$props.isSelected,
        t = _this$props.t;
      var defaultValue = this.getDefaultOption();
      return /*#__PURE__*/React.createElement("span", attributes, /*#__PURE__*/React.createElement(Select, {
        isSelected: isSelected,
        placeholder: t('Select_field'),
        value: defaultValue,
        options: this.options,
        onChange: this.onColumnChanged
      }), children);
    }
  }]);
  return Column;
}(React.Component);
export default withTranslation('seafile-editor')(Column);